import { FadeTransition } from "@9amhealth/shared";
import type { FC } from "react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import type {
  SignupCustomStep,
  SignupCustomStepSuccessPage
} from "src/ui/components/SignupCustomContent/SignupCustom.types";
import { SignupCustomStepType } from "src/ui/components/SignupCustomContent/SignupCustom.types";
import SignupSuccessPage from "src/ui/components/SignupCustomContent/SignupSuccessPage";

const SignupCustomStepSuccessContent: FC<{
  step: SignupCustomStepSuccessPage;
}> = ({ step }) => {
  const { successPageProps } = step;
  const navigate = useNavigate();

  useEffect(() => {
    if (step.action) {
      step.action(navigate);
    }
  }, [step.action]);

  return (
    <FadeTransition show fitParent>
      <SignupSuccessPage {...successPageProps} />
    </FadeTransition>
  );
};

const SignupCustomStepSuccess: FC<{
  step: SignupCustomStep;
}> = React.memo(({ step }) => {
  const isSuccessPage = step.type === SignupCustomStepType.SuccessPage;
  return isSuccessPage ? <SignupCustomStepSuccessContent step={step} /> : null;
});

export default SignupCustomStepSuccess;
